export default {
  nav: {
    home: 'Accueil',
    rsvp: 'Confirmation',
    guestbook: "Livre d'or",
    hotels: 'Hébergement',
    erlangen: 'Erlangen',
    admin: 'Admin',
  },
  home: {
    hero_title: 'Michel fête ses 50 ans !',
    hero_subtitle: 'Une soirée inoubliable · Erlangen · Juillet 2026',
    info_cocktail_title: 'Apéro',
    info_cocktail_time: '17h00',
    info_dinner_title: 'Soirée de gala',
    info_dinner_time: '',
    info_dinner_note: 'Adultes uniquement',
    info_venue_title: 'Lieu',
    info_venue_value: 'Erlangen, Allemagne',
    info_dresscode_title: 'Dress code',
    info_dresscode_value: 'Élégance inspirée de l\'identité africaine ou bavaroise',
    welcome_text:
      "C'est avec joie que je vous invite à célébrer ce moment unique avec moi. Votre présence sera le plus beau des cadeaux.",
    cta_rsvp: 'Confirmer ma présence',
    hero_eyebrow: "Invitation à fêter mes",
    hero_title_word: "Anniversaire",
    hero_motto: "Je n'ai jamais été seul !",
    hero_date: "SAMEDI · 11 JUILLET 2026 · ERLANGEN",
    hero_children_note: "Aussi j'adore les enfants — le Gala-Abend est réservé aux adultes",
    hero_venue: "Sieboldstr. 3 · 91052 Erlangen",
    hero_deadline: "Répondre avant le 7 juin 2026",
  },
  rsvp: {
    title: 'Confirmer ma présence',
    subtitle: 'Merci de remplir ce formulaire avant le 1er juin 2026',
    first_name: 'Prénom *',
    last_name: 'Nom *',
    email: 'Email',
    phone: 'Téléphone',
    attendance: 'Participation',
    attendance_solo: 'Je viens seul(e)',
    attendance_with_guest: 'Je viens avec un(e) accompagnant(e)',
    attendance_no: 'Non, je ne pourrai malheureusement pas venir',
    dietary_needs:
      'Besoins particuliers (régime alimentaire, mobilité réduite, etc...)',
    message: 'Message personnel (optionnel)',
    gdpr_consent:
      "J'accepte que mes données soient utilisées uniquement pour l'organisation de cet événement (RGPD) *",
    submit: 'Confirmer ma présence',
    success_title: 'Merci pour votre confirmation !',
    success_text:
      'Votre présence a bien été enregistrée. À très bientôt !',
    error: 'Une erreur est survenue. Veuillez réessayer.',
    required_fields: 'Veuillez remplir tous les champs obligatoires.',
    code_title: "Code d'invitation",
    code_subtitle: "Entrez le code reçu avec votre invitation",
    code_label: "Code d'invitation *",
    code_placeholder: "XXXXXX",
    code_validate: "Valider le code",
    code_validated: "Code validé",
    code_invalid: "Code invalide ou déjà utilisé",
    code_error: "Erreur lors de la vérification du code",
  },
  guestbook: {
    title: "Livre d'or",
    subtitle: 'Laissez un message pour Michel',
    name: 'Votre nom *',
    message: 'Votre message *',
    submit: 'Publier mon message',
    success: 'Merci ! Votre message sera publié après validation.',
    error: 'Une erreur est survenue. Veuillez réessayer.',
    no_messages: "Aucun message pour l'instant. Soyez le premier !",
    messages_title: 'Les messages',
  },
  admin: {
    title: 'Espace Administrateur',
    login_title: 'Connexion',
    username: "Nom d'utilisateur",
    password: 'Mot de passe',
    login_btn: 'Se connecter',
    login_error: 'Identifiants incorrects',
    logout: 'Déconnexion',
    guests_tab: 'Invités',
    guestbook_tab: "Livre d'or",
    codes_tab: 'Codes',
    codes_total: 'Total codes',
    codes_used: 'Utilisés',
    codes_available: 'Disponibles',
    codes_generate: 'Générer 200 codes',
    codes_export: 'Exporter CSV',
    codes_delete_unused: 'Supprimer les non-utilisés',
    codes_delete_confirm: 'Supprimer tous les codes non utilisés ? Cette action est irréversible.',
    codes_generated: 'codes générés',
    code_col: 'Code',
    code_status_col: 'Statut',
    code_used_at_col: 'Utilisé le',
    code_available: 'Disponible',
    code_used: 'Utilisé',
    total_guests: 'Inscriptions',
    attending_count: 'Présents',
    not_attending_count: 'Absents',
    export_csv: 'Exporter CSV',
    approve: 'Valider',
    hide: 'Masquer',
    status_approved: 'Validé',
    status_pending: 'En attente',
    name_col: 'Nom',
    email_col: 'Email',
    plus_ones_col: 'Accompagnants',
    attending_col: 'Participation',
    dietary_col: 'Besoins',
    date_col: 'Date',
    yes: 'Oui',
    no: 'Non',
  },
  privacy: {
    title: 'Politique de confidentialité',
    content: `**Collecte des données**

Dans le cadre de l'organisation de cet événement privé, nous collectons les informations suivantes : prénom, nom, coordonnées, préférences de participation et besoins particuliers.

**Utilisation des données**

Ces données sont utilisées exclusivement pour l'organisation de la fête des 50 ans de Michel (juillet 2026, Erlangen). Elles ne sont en aucun cas transmises à des tiers.

**Conservation**

Les données seront supprimées 6 mois après l'événement.

**Droits**

Conformément au RGPD, vous disposez d'un droit d'accès, de rectification et de suppression de vos données. Pour exercer ces droits, contactez l'organisateur.

**Responsable du traitement**

Événement privé · Erlangen · 2026`,
  },
  erlangen: {
    tag: 'Conseils voyage',
    title: 'Découvrir Erlangen',

    shopping_title: 'Shopping à Herzogenaurach : berceau d\'Adidas et Puma',
    shopping_intro:
      'À deux pas d\'Erlangen se trouve Herzogenaurach, ville natale des géants du sport Adidas et Puma. Les outlets locaux sont une destination idéale pour les amateurs de shopping en quête d\'articles de marque à prix attractifs.',
    shopping_addresses: 'Adresses importantes pour votre excursion shopping :',
    shopping_adidas: 'adidas Outlet Store : Olympiaring 2, 91074 Herzogenaurach',
    shopping_puma: 'PUMA Outlet : Puma Way 1, 91074 Herzogenaurach',
    shopping_others: 'Autres outlets de marques : concentrés dans la Zeppelinstraße (ex. s.Oliver).',
    shopping_note:
      'Remarque : la plupart des outlets sont ouverts du lundi au vendredi de 09h00 à 20h00 et le samedi jusqu\'à 18h00 ou 19h00. Veuillez vérifier les horaires actuels avant votre visite.',

    culture_title: 'Culture et gastronomie',
    culture_intro:
      'Erlangen est réputée pour sa culture des jardins brassicoles, particulièrement agréables en été. Qu\'ils soient traditionnels sous l\'ombre des arbres ou au bord de la Regnitz — la bière locale et les spécialités franconniennes sont incontournables.',
    culture_subtitle: 'Biergartens et caves à bière recommandés',
    biergaerten: [
      {
        name: 'Steinbach Bräu',
        desc: 'Jardin brassicole historique en plein cœur de la ville, connu pour ses bières créatives et ses classiques comme la Schäufele ou la Bratwurst. Point fort : la webcam en direct sur les cigognes.',
        url: 'https://steinbach-braeu.de',
      },
      {
        name: 'Entlas-Keller',
        desc: 'Classique rustique dans le quartier des caves d\'Erlangen. Atmosphère ombragée, large choix de spécialités régionales et très familial.',
        url: 'https://entlaskeller.de',
      },
      {
        name: 'Kitzmann Bräuschänke',
        desc: 'Jardin brassicole classique avec décoration rustique. La carte comprend des plats traditionnels comme le jarret et diverses variantes de schnitzel.',
        url: null,
      },
      {
        name: 'Gaststätte am Röthelheim',
        desc: 'Jardin brassicole central entouré de verdure, avec une carte variée incluant cuisine franconienne et options végétariennes et véganes.',
        url: 'https://www.gaststätte-am-röthelheim.de',
      },
      {
        name: 'Thalermühle',
        desc: 'Établissement au cachet historique, apprécié pour son bel espace extérieur. Idéal pour des soirées détendues avec petits plats à partager.',
        url: null,
      },
    ],

    siemens_title: 'Erlangen — La ville Siemens',
    siemens_text:
      'Erlangen est étroitement liée à Siemens AG, dont elle abrite le plus grand site de développement et d\'administration. La ville est un important centre de recherche et de technologie pour la région. Un passage par la Siemenspromenade donne un aperçu de la puissance économique du site.',

    vacation_title: 'Planifier un séjour',
    vacation_text:
      'Pour découvrir les multiples facettes de la région métropolitaine de Nuremberg à votre rythme, il vaut la peine de prévoir un peu plus de temps et de combiner la visite avec quelques jours de vacances.',
  },
  hotels: {
    tag: 'Hébergement',
    title: 'Hôtels à Erlangen',
    intro: "Pour votre séjour à Erlangen, nous avons listé les hôtels ci-dessous pour vous. Ils se trouvent dans un rayon de 4 km de la salle de fête (Sieboldstr. 3, 91052 Erlangen).",
    platforms_note: "Nous vous recommandons également d'utiliser",
    or: 'ou',
    platforms_suffix: 'pour plus de détails et de disponibilités.',
    reference: 'Référence : Sieboldstr. 3, 91052 Erlangen · Rayon 4 km',
    col_rang: '#',
    col_name: 'Hôtel',
    col_address: 'Adresse',
    col_distance: 'Distance',
    col_min: 'Prix min',
    col_max: 'Prix max',
    col_note: 'Particularité',
    price_note: 'Les prix sont indicatifs et peuvent varier selon la saison et la disponibilité.',
  },
  common: {
    loading: 'Chargement...',
    back: 'Retour',
  },
};
